/**
 * Exportul din /rapoarte/inscrieri NU cheama endpointul grilei. Grila citeste
 * `/api/school-requests/report` (SchoolRequestReportDTO, cu `professor.*` imbricat), iar butonul
 * «Export» cheama `/api/users/school-requests/report` (ProfesorReportDTO, plat, prin
 * `ProfessorReportQuery`). Cheile de filtru ale grilei nu exista acolo si `QueryUtils` le
 * sare in tacere: masurat pe DEV 2026-09-15, grila filtrata pe un singur email a exportat toti
 * cei 54 de profesori ai editiei.
 *
 * Functia traduce filtrul grilei in cheile pe care le recunoaste `getFieldMappings()` din
 * `ProfessorReportQuery`. Cheile care au deja acelasi nume trec neschimbate.
 *
 * ⚠️ Doua limite care NU se repara aici, ci in backend (b31) — masuratorile sunt in
 * `docs/knowledge/export-rapoarte-filtre.md`:
 *  1. `ReportServiceMapper` citeste parametrii URL-ului interior fara sa-i decodeze. O valoare cu
 *     `@`, spatiu sau diacritice ajunge in SQL codata (`%40`, `%20`) si nu se potriveste cu nimic:
 *     exportul iese GOL. Emailul complet sau un nume cu spatiu filtreaza abia dupa fix-ul backend;
 *     fragmentele fara astfel de caractere functioneaza deja.
 *  2. Intervalele de date dau HTTP 500 pe export, in orice format. Nu le trimitem deloc: altfel
 *     un filtru ignorat (exportul iese nefiltrat pe data) ar deveni un export picat.
 */

const REDENUMIRI: Record<string, string> = {
    'professor.email': 'email',
    'professor.nume': 'nume',
    'professor.isEnabled': 'isEnabled',
    'professor.hasSchoolRegistrationFormCompleted': 'hasSchoolRegistrationFormCompleted',
    'professor.phoneCallNote': 'phoneCallNote',
    // In grila, `telefon` e telefonul din cerere, adica al institutiei (`sr.telefon`). In export,
    // `telefon` e al profesorului (`u.telefon`), iar al institutiei se numeste `telefonInstitutie`.
    telefon: 'telefonInstitutie',
    'professor.telefon': 'telefon',
};

/** Cheile de interval ale grilei: nu se trimit exportului pana nu repara backendul 500-ul (vezi mai sus). */
const INTERVALE_NETRIMISE = new Set([
    'professor.timestampInregistrare.start',
    'professor.timestampInregistrare.end',
    'timestamp.start',
    'timestamp.end',
]);

export function filtruPentruExportProfesori(filtru: Record<string, unknown>): Record<string, unknown> {
    const rezultat: Record<string, unknown> = {};
    for (const [cheie, valoare] of Object.entries(filtru)) {
        if (valoare === undefined || valoare === null || valoare === '') continue;
        if (INTERVALE_NETRIMISE.has(cheie)) continue;
        rezultat[REDENUMIRI[cheie] ?? cheie] = valoare;
    }
    return rezultat;
}
